// CustomAdherenceRechartsTooltip.tsx
import { useTranslation } from "react-i18next";
import { TooltipProps } from "recharts";
import {
  NameType,
  ValueType,
} from "recharts/types/component/DefaultTooltipContent";

import { IGetPatientAdherenceDataResponse } from "../../../../../../@types/Treatments";
import { AdherenceCategory } from "../../AdherenceGraph";
import { adherenceDescriptionKeys } from "./CustomAdherenceRechartsTooltip.config";
import { StyledTooltip } from "./CustomAdherenceRechartsTooltip.styles";

interface IRowPayload {
  label: string;
  type: AdherenceCategory;
  value: number;
  fill: string;
}

type CustomTooltipProps = TooltipProps<ValueType, NameType> & {
  data: IGetPatientAdherenceDataResponse;
};

export function CustomAdherenceRechartsTooltip({
  active,
  payload,
  data,
}: CustomTooltipProps) {
  const { t } = useTranslation();

  if (!active || !payload || payload.length === 0) return null;

  const row = payload[0].payload as IRowPayload;
  const value = payload[0].value as number;

  const handleCategoryDescription = () => {
    const key = adherenceDescriptionKeys[row.type as AdherenceCategory];
    return key ? t(key) : "";
  };

  return (
    <StyledTooltip>
      <h4 style={{ margin: 0 }}>
        <b>{`${data.protocolName} (${data.actionTimes.join(", ")})`}</b>
      </h4>
      <p>{handleCategoryDescription()}</p>
      <h4>{t("dashboard_graph_patientCount", { count: value })}</h4>
    </StyledTooltip>
  );
}
